import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { common as commonApi } from 'redux/modules/api'

function decorator(config = {}) {
  return ComposedComponent => {
    @connect(
      ({ api }) => ({
        common: api.common
      }),
      { ...commonApi }
    )
    class Common extends Component {
      static propTypes = {
        common: PropTypes.object.isRequired,
        getCountries: PropTypes.func.isRequired,
        getPublicCountries: PropTypes.func.isRequired,
        getRegions: PropTypes.func.isRequired,
        getPublicRegions: PropTypes.func.isRequired,
        getAwardLevels: PropTypes.func.isRequired
      }

      UNSAFE_componentWillMount() {
        if (config.fetchOnClient) {
          return
        }

        this.fetchCommon()
      }

      componentDidMount() {
        if (!config.fetchOnClient) {
          return
        }

        this.fetchCommon()
      }

      fetchCommon = () => {
        const {
          common,
          getRegions,
          getPublicRegions,
          getCountries,
          getPublicCountries,
          getAwardLevels
        } = this.props

        if (config.countries) {
          !common.countries.loading && getCountries()
        }

        if (config.publicCountries) {
          !common.countries.loading &&
            getPublicCountries({ rejectEmpty: config.rejectEmpty })
        }

        if (config.regions) {
          !common.regions.loaded && getRegions()
        }

        if (config.publicRegions) {
          !common.regions.loaded && getPublicRegions()
        }

        if (config.awardLevels) {
          !common.awardLevels.loaded && getAwardLevels()
        }
      }

      render() {
        return <ComposedComponent {...this.props} />
      }
    }
    return Common
  }
}

export default decorator
